import { Star } from "lucide-react";

const items = [
  "5-Star Rated on Trustpilot",
  "Licensed & Insured",
  "Same-Day Service",
  "Upfront Pricing",
  "24/7 Emergency Calls",
  "Workmanship Warranty",
  "Local Prosper Techs",
];

export default function TrustStrip() {
  return (
    <section className="bg-slate-950 text-slate-300 border-y border-white/10 overflow-hidden">
      <div className="relative flex whitespace-nowrap py-3.5">
        <div className="flex animate-marquee shrink-0">
          {[...items, ...items].map((t, i) => (
            <span key={i} className="flex items-center gap-2 px-6 text-sm font-semibold">
              <Star className="h-3.5 w-3.5 fill-red-600 text-red-600" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
